<template>
  <div class="user-entered">
    <van-tabs v-model="active" :swipe-threshold="4">
      <van-tab title="全部订单" :name="0"></van-tab>
      <van-tab title="待付款" :name="1"></van-tab>
      <van-tab title="待发货" :name="2"></van-tab>
      <van-tab title="已发货" :name="3"></van-tab>
      <van-tab title="已超时/已取消" :name="4"></van-tab>
    </van-tabs>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh" :disabled="isPulling">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <van-swipe-cell v-for="item in list" :key="item.orderId" :title="item.goodsName" :class="{ animation: item.animation }" :disabled="isAndroid" :stop-propagation="true">
          <van-cell
            :border="false"
            :title="item.date"
            value=""
            @touchstart.native="openMenu($event, 'start', item)"
            @touchmove.native="openMenu($event, 'move', item)"
            :class="{ 'count-down': item.goodsTypeId === 4 && item.orderFlg === 6 }"
          >
            <template #title>
              <van-image :src="item.picPath">
                <!-- 图标加载失败 -->
                <template #error>
                  <van-icon name="photo-o" />
                </template>
              </van-image>
            </template>
            <template>
              <div>
                <p>
                  订单编号<span>{{ item.orderId }}</span>
                </p>
                <p>
                  商品名称<span>{{ item.goodsName }}</span>
                </p>
                <p>
                  订单金额<span>￥{{ item.totalPrice.toFixed(2) }}</span>
                </p>
                <p>
                  订单数量<span>{{ item.goodsNum }}</span>
                </p>
              </div>
              <div>
                <p v-if="((item.orderFlg !== 1 || item.paymentFlag !== 0) && item.orderFlg !== 6) || (item.orderFlg === 1 && item.paymentFlag === 0)">
                  {{ getOrderType(item.orderFlg, item.goodsTypeId, item.paymentFlag) }}
                </p>
                <p class="refund" v-if="item.goodsTypeId === 4 && (item.orderFlg === 10 || (item.orderFlg === 4 && (item.paymentFlag === 12 || item.paymentFlag === 14)))">
                  <span class="success" v-if="item.paymentFlag === 11">退款成功</span>
                  <span class="ing" v-else-if="item.paymentFlag === 13">退款中</span>
                  <span class="fail" v-else>退款失败</span>
                </p>
                <van-button class="list-in" type="primary" text="支付" v-if="(item.orderFlg === 1 && item.paymentFlag === 0) || item.orderFlg === 6" @click="payment(item.orderId)" />
                <template v-if="item.goodsTypeId === 4 && item.orderFlg === 6">
                  <p style="margin-top: 0.5rem; line-height: 1rem">剩余时间<br />{{ item.downCountString }}</p>
                  <div>
                    <p>请于15分钟内付款，否则订单将会关闭</p>
                  </div>
                </template>
              </div>
            </template>
          </van-cell>
          <div class="footer" v-if="item.goodsTypeId === 4 && (item.orderFlg === 4 || item.orderFlg === 5 || item.orderFlg === 10)">
            <van-button class="check" type="primary" text="查看" @click="browseDetail(item.orderId)" />
          </div>
          <template #right>
            <!-- <van-button square type="primary" text="支付" v-if="(item.orderFlg === 1 && item.paymentFlag === 0) || item.orderFlg === 6" @click="payment(item.orderId)" /> -->
            <van-button square type="danger" text="移出" @click="overTimeOrderDelete(item.orderId)" v-if="item.goodsTypeId === 4 && item.orderFlg === 7" />
            <van-button square type="warning" text="查看" @click="browseDetail(item.orderId)" v-if="item.goodsTypeId === 4 && (item.orderFlg === 4 || item.orderFlg === 5)" />
            <van-button square type="danger" text="取消" @click="cancelPayOrder(item.orderId)" v-if="(item.orderFlg === 1 && item.paymentFlag === 0) || item.orderFlg === 6" />
          </template>
        </van-swipe-cell>
      </van-list>
    </van-pull-refresh>
    <!-- 安卓菜单 -->
    <div class="custom-menu" ref="menu" :class="{ menuShow: customMenu.show }" :style="{ left: customMenu.x + 'px', top: customMenu.y + 'px' }">
      <!-- <van-button square type="primary" text="支付" v-if="(customMenu.orderFlg === 1 && customMenu.paymentFlag === 0) || customMenu.orderFlg === 6" @click="payment(customMenu.orderId)" /> -->
      <van-button square type="danger" text="移出" @click="overTimeOrderDelete(customMenu.orderId)" v-if="customMenu.goodsTypeId === 4 && customMenu.orderFlg === 7" />
      <van-button square type="warning" text="查看" @click="browseDetail(customMenu.orderId)" v-if="customMenu.goodsTypeId === 4 && (customMenu.orderFlg === 4 || customMenu.orderFlg === 5)" />
      <van-button square type="danger" text="取消" @click="cancelPayOrder(customMenu.orderId)" v-if="(customMenu.orderFlg === 1 && customMenu.paymentFlag === 0) || customMenu.orderFlg === 6" />
    </div>
  </div>
</template>

<script>
  // 混入文件
  import { userCentered } from '@/mixins/reception/userCentered'
  // hooks
  export default {
    mixins: [userCentered],
    data() {
      return {
        active: 0, // 订单状态切换
        list: [],
        loading: false,
        finished: false,
        refreshing: false,
        orderId: 0, // 提交支付回调接口参数
        isAndroid: /android/gi.test(window.navigator.userAgent),
        isPulling: false
      }
    },
    created() {
      let { type } = this.$route.query
      this.active = Number.parseInt(type) || Number.parseInt(window.sessionStorage.getItem('active')) || 0
      document.documentElement.onclick = () => {
        this.customMenu.show = false
      }
    }
  }
</script>

<style lang="scss" scoped>
  @keyframes deleteItem {
    from {
      height: 8rem;
      opacity: 1;
    }
    to {
      height: 0;
      opacity: 0;
    }
  }
  @keyframes menuShow {
    from {
      opacity: 0;
      transform: scale(0);
    }
    70% {
      transform: scale(1.2);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }

  .user-entered {
    /deep/ .van-pull-refresh {
      padding: 0.5rem;
      .van-button:not(.list-in) {
        height: 100%;

        &.van-button--primary {
          background-color: #27c49a !important;
          border: 1px solid #27c49a !important;
          padding: 0 15px !important;
        }
        &.van-button--danger {
          background-color: #ff5757 !important;
          border: 1px solid #ff5757 !important;
        }
        &.van-button--warning {
          background-color: #ffad5c !important;
          border: 1px solid #ffad5c !important;
        }
      }
      .van-button.list-in,
      .van-button.list-in div {
        height: auto;
        color: #fff !important;
        text-align: center;
        margin: 0 auto;
        padding: 0 2vw !important;
        line-height: 2;
        .van-button__content {
          position: inherit;
          width: auto;
          right: inherit;
          bottom: 0;
          padding: 0;
          white-space: nowrap;
        }
      }
    }
    .van-cell__title,
    .van-cell__value {
      color: #000;
    }
    .animation {
      animation: deleteItem 0.4s;
      height: 0;
      padding: 0;
      overflow: hidden;
      opacity: 0;
    }
    /deep/ .van-cell {
      padding: 0.8rem 0 0;
      margin-bottom: 0.5rem;
      &.count-down {
        padding: 1rem 0;
        .van-cell__value {
          padding: 0 0.5rem 1.5rem 0;
        }
      }
    }
    /deep/ .van-cell__title {
      flex: 0.6;
      width: 100%;
      text-align: center;
      display: flex;
      justify-content: center;
      .van-image {
        padding: 0 0.5rem;
        .van-image__img {
          height: auto;
        }
        .van-image__error {
          font-size: 2rem;
          display: flex;
          align-items: center;
          background-color: transparent;
        }
      }
    }
    /deep/ .van-cell__value {
      padding: 0 0.5rem 1rem 0;
      flex: 1.5;
      text-align: left;
      font-size: 0.7rem;
      display: flex;
      justify-content: space-between;
      p {
        margin: 0;
        line-height: 1.8;
        display: flex;
        font-size: 0.8rem;
        span {
          margin-left: 1rem;
          flex: 10;
        }
      }
      div:first-of-type {
        width: 70%;
      }
      div:last-of-type {
        // flex: 1;
        // position: relative;
        width: 4rem;
        padding: 0 0.5rem;
        text-align: center;
        p {
          // text-align: right;
          color: #ff5757;
          min-width: 3rem;
          display: block;
          text-align: right;
          padding-right: 0.5rem;
        }
        div {
          position: absolute;
          width: 100%;
          right: 1rem;
          bottom: -0.1rem;
          text-align: center;
          // transform: scale(1);
          color: #ff5757;
          p:first-of-type {
            line-height: 1.4;
            margin-bottom: 0.3rem;
            font-size: 0.7rem;
            text-align: right;
          }
          p:last-of-type {
            color: #aaa;
            transform: scale(0.9);
            transform-origin: right;
            text-align: right;
          }
        }
      }
    }
    .custom-menu {
      &.menuShow {
        animation: menuShow 0.3s ease;
        opacity: 1;
        transform: scale(1);
      }
      width: 25%;
      position: fixed;
      user-select: none;
      opacity: 0;
      transform: scale(0);
      box-shadow: 0 1px 10px #ccc;
      .van-button {
        width: 100%;
        padding: 0.8rem 15px !important;
        height: 2.5rem;
        user-select: none;
        background-color: #fff !important;
        color: #000;
        border: 0px !important;
      }
    }
    @media screen and (min-width: 768px) {
      /deep/ .van-cell__title {
        flex: inherit;
        width: 100px;
        height: 100px;
      }
      .van-cell__value p {
        line-height: 2;
      }
    }
    .footer {
      border-top: 1px solid #f0f0f0;
      height: 3rem;
      width: 100%;
      line-height: 2rem;
      text-align: right;
      padding: 0 1.5rem;
      background: #fff;
      box-sizing: border-box;
      margin-top: -0.5rem;
      margin-bottom: 0.5rem;
      /deep/.van-button.check {
        height: 100%;
        margin-right: 0.5rem !important;
        &:last-of-type {
          margin-right: 0 !important;
        }
        &.van-button--primary {
          width: 3rem;
          height: 1.5rem;
          background-color: #ffd8d8 !important;
          border-color: #ffd8d8 !important;
          border-radius: 0.25rem;
          font-weight: 400;
          font-size: 0.75rem;
          letter-spacing: 0;
          line-height: 1rem;
          color: #fe5756;
        }
        &.van-button--danger {
          width: 3rem;
          height: 1.5rem;
          background-color: #ff5757 !important;
          border: 1px solid #ff5757 !important;
          border-radius: 0.25rem;
          font-weight: 400;
          font-size: 0.75rem;
          letter-spacing: 0;
          line-height: 1rem;
          color: #fff;
        }
        &.van-button--warning {
          width: 3rem;
          height: 1.5rem;
          background-color: #ffad5c !important;
          border: 1px solid #ffad5c !important;
          border-radius: 0.25rem;
          font-weight: 400;
          font-size: 0.75rem;
          letter-spacing: 0;
          line-height: 1rem;
          color: #fff;
        }
      }
      /deep/.van-button.check {
        text-align: center;
        margin: 0 auto;
        padding: 0 2vw !important;
        line-height: 2;
        .van-button__content {
          position: inherit;
          width: auto;
          right: inherit;
          bottom: 0;
          padding: 0;
          white-space: nowrap;
        }
      }
    }
    .refund {
      position: absolute;
      bottom: 1rem;
      right: 1rem;
      .fail {
        color: #fe5756;
      }
      .success {
        color: #32ae57;
      }
      .ing {
        color: #ffaf4f;
      }
    }
  }
</style>
